import { useEffect, useState } from 'react';
import ControlService from './ControlService';

// Integración con el MTESS (control.usa_mtess). Si está apagada se ocultan los
// accesos, columnas y acciones de MTESS. Mientras no se sabe, o si la columna
// todavía no existe, se asume habilitada para no esconder nada.
let cache = null;
const suscriptores = new Set();

function cargar() {
    if (!cache) {
        cache = ControlService.getControl()
            .then(result => {
                const control = result && result.data && result.data.data && result.data.data[0];
                return !control || control.usa_mtess !== false;
            })
            .catch(() => true);
    }
    return cache;
}

// Para llamar después de guardar la configuración.
export function actualizarMtessHabilitado(habilitado) {
    cache = Promise.resolve(habilitado !== false);
    suscriptores.forEach(notificar => notificar());
}

export default function useMtessHabilitado() {
    const [habilitado, setHabilitado] = useState(true);

    useEffect(() => {
        let vigente = true;
        const leer = () => cargar().then(valor => { if (vigente) setHabilitado(valor) });

        leer();
        suscriptores.add(leer);
        return () => {
            vigente = false;
            suscriptores.delete(leer);
        };
    }, []);

    return habilitado;
}
